import axios from 'axios';

const API_URL = process.env.REACT_APP_BASEURL + 'division';

export const addDivision = (divisionReqData: Object) => {
  return axios.post(API_URL + '/add', divisionReqData); // reqData => {search: "text", limit: number, skip: limit}
};

export const getAllDivision = (reqData: Object) => {
  return axios.get(API_URL + '/all', { params: reqData }); // reqData => {search: "text", limit: number, skip: limit}
};

export const getDivision = (reqData: Object) => {
  return axios.get(API_URL + '/', reqData); // reqData => {search: "text", limit: number, skip: limit}
};

export const updateDivision = (updateDivision: Object) => {
  return axios.put(API_URL + '/', updateDivision); // reqData => {search: "text", limit: number, skip: limit}
};

export const deleteDivision = (deleteReq: Object) => {
  return axios.delete(API_URL + '/', { params: deleteReq }); // reqData => {search: "text", limit: number, skip: limit}
};

export const getAllDBDivision = (reqData: Object) => {
  return axios.get(API_URL + '/list', { params: reqData }); // reqData => {search: "text", limit: number, skip: limit}
};

export const divisionTimeoff = (reqData: Object) => {
  return axios.post(API_URL + '/division-timeoff', reqData);
};

export const toggleDivisionStatus = (payload: { divisionId: string; isActive: boolean }) => {
  return axios.put(API_URL + '/toggle-active', payload);
};

export const timeoffDivision = (reqData: Object) => {
  return axios.get(API_URL + '/division-timeoff', { params: reqData });
};